/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { RoutewareCalendarComponentDisplay } from "cms/components/components/routeware-calendar/display";
import { RoutewareCalendarComponentEditor } from "cms/components/components/routeware-calendar/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

function RoutewareCalendarComponent (props) {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <RoutewareCalendarComponentDisplay />,
        editComponent: <RoutewareCalendarComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
}

RoutewareCalendarComponent.displayName = "RoutewareCalendarComponent";
export { RoutewareCalendarComponent };
